// 這是Webpack掛載起始點
import Layout from './layout.vue'
import Index from '@staffs/.components/provider/index.vue'
import New from '@staffs/.components/provider/new.vue'
import Edit from '@staffs/.components/provider/edit.vue'

const main_router = 'staffs';
const new_router = 'new_staff';
const edit_router = 'edit_staff';

const router = [
    {
        path: '/',
        component: Index,
        name: 'staffs',
        meta: {
            api_name: 'api_v1_provider_staffs',
            breadcrumb: [main_router],
            btns: [new_router]
        }
    },
    {
        path: 'new',
        component: New,
        name: 'new_staff',
        meta: {
            api_name: 'api_v1_provider_staffs_create',
            breadcrumb: [main_router, new_router]
        }
    },
    {
        path: ':identity/edit',
        component: Edit,
        name: 'edit_staff',
        meta: {
            api_name: 'api_v1_provider_staff_update',
            breadcrumb: [main_router, edit_router]
        }
    }
]


export default router;
